import { Injectable, isDevMode } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { SocketsLibService, ReactiveSocket } from 'sockets-lib';

interface LimboChannel {
  url: string;
  channel: string;
  path: string;
}

@Injectable({
  providedIn: 'root'
})
export class CommunicationDaoService {

  private BASE_URL = environment.apiURL;

  constructor(private socketsService: SocketsLibService) { }

  public getLimboChannel(lang: string): Observable<LimboChannel> {
    return new Observable<LimboChannel>(
      (o) => {
        this.socketsService.getLimboChannel(this.BASE_URL + '/api/v2.0/deviceCommunication/ws_getLimboChannel', lang).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res['data']);
          }
        );
      }
    );
  }

  public getChannel(context: string, udid: string, lang: string): Observable<LimboChannel> {
    return new Observable<LimboChannel>(
      (o) => {
        this.socketsService.getChannel(this.BASE_URL + '/api/v2.0/deviceCommunication/ws_getMyChannel', context, udid, lang).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res['data']);
          }
        );
      }
    );
  }

  public connect(url, channel, opts?): ReactiveSocket {
    return this.socketsService.connect('https://' + url, channel, opts);
  }

}
